import React from 'react';
import Helmet from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import { useIntl } from 'react-intl';

interface Props {
  title: string;
}

/**
 * @description
 * Use this component to set a <title> for client-side rendered pages only.
 * It will automatically set <html lang=""> for you (to help with in-browser translation tools)
 * and disallows robots to index the page, just to be on the safe side.
 * For statically rendered pages (anything in ./src/templates) use Seo.tsx instead.
 */
const PrivateHead = ({ title }: Props) => {
  const { site } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            configuration {
              channel {
                name
                siteUrl
              }
            }
          }
        }
      }
  `,
  );

  const intl = useIntl();
  const portalConfiguration = site.siteMetadata.configuration;
  const channelName = portalConfiguration.channel.name;

  const titleTemplate = `${title} | ${channelName}`;

  return (
    <Helmet
      htmlAttributes={{ lang: intl.locale }}
      title={titleTemplate}
      meta={[
        {
          name: 'robots',
          content: 'noindex,nofollow',
        }]}
    />
  );
};

export default PrivateHead;
